import * as React from 'react'

function SvgFunArrowRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M9 20a.999.999 0 01-.707-1.707L14.586 12 8.293 5.707a.999.999 0 111.414-1.414l7 7a.999.999 0 010 1.414l-7 7A.997.997 0 019 20" />
    </svg>
  )
}

export default SvgFunArrowRight
